exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".order-over-time-modal {\n  color: #231f20;\n  font-family: \"Source Sans Pro\", sans-serif;\n  text-align: center;\n  padding: 3.5rem 0; }\n  .order-over-time-modal .title {\n    display: block;\n    font-size: 2em;\n    font-weight: bold;\n    line-height: 1;\n    margin-bottom: 1rem; }\n  .order-over-time-modal .text {\n    display: block;\n    font-size: 1.15em;\n    margin-bottom: 2.5rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/OrderOverTimeModal/OrderOverTimeModal.scss
// module id = 1503
// module chunks = 0